import styled, { css } from 'react-emotion';
import { mq } from '@sthzg/sthzgnet-base';

const NarrowPage = styled.div`
  width: 90%;
  max-width: 640px;
  margin: 2vh auto auto;
  padding-bottom: 96px;
  ${mq.medium(css`
    margin-top: 10vh;
  `)};
`;

export default NarrowPage;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/NarrowPage/NarrowPage.jsx